import type React from 'react';
import { useStore } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';
import { DEFAULT_VALUE, metricsTrackerAtom } from './metrics-atom';
import type { MetricsTrackerT } from './types';
type PropsT = {
  metricsTracker?: MetricsTrackerT;
  children: React.ReactNode;
};
export const MetricsHydrator = ({
  metricsTracker,
  children
}: PropsT) => {
  const store = useStore();
  useHydrateAtoms([[metricsTrackerAtom, metricsTracker ?? DEFAULT_VALUE]], {
    store
  });
  return children;
};